import { HcLazyload } from '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component'

export default class BlockCustomerSejoursList {
    constructor() {
        if ($('[data-element="block-customer-sejours-list"]').length > 0) {
            BlockCustomerSejoursList.displayFilters()

            document.addEventListener('facetwp-loaded', () => {
                BlockCustomerSejoursList.checkEmptyFilters()
                BlockCustomerSejoursList.priceSlideRange()
            })
        }

        document.addEventListener('facetwp-loaded', () => {
            HcLazyload.update()
        })
    }

    static displayFilters() {
        if ($('[data-trigger="sejours-filters-toggle"]').length > 0) {
            $('[data-trigger="sejours-filters-toggle"]').on('click', function () {
                $(this).toggleClass('opened')
                $('[data-trigger="sejours-filters-list"]').toggleClass('open')
            })
        }
    }

    static checkEmptyFilters() {
        setTimeout(() => {
            $('.block__customer__sejours-list__filters__filter').each(function () {
                if ($(this).find('.facetwp-facet').html().length === 0) {
                    $(this).hide()
                }
            })
        }, 2000)
    }

    static async priceSlideRange() {
        if ($('.filter_price').length > 0) {
            const rangeSlider = document.getElementById('priceRange')
            // check if uislider is already build
            if (!$('#priceRange').hasClass('noUi-target')) {
                const minValue = $('#priceRange').data('min-value')
                const maxValue = $('#priceRange').data('max-value')
                let minValueDefault = minValue
                let maxValueDefault = maxValue

                // get filters when refresh page
                const url = new URL(location.href)
                const userSearchPrice = url.searchParams.get('_trip_price')
                if (userSearchPrice) {
                    const userSearchPrices = userSearchPrice.split(',')
                    minValueDefault = userSearchPrices[0]
                    maxValueDefault = userSearchPrices[1]
                }
                const noUiSlider = await import('nouislider')
                await import('nouislider/dist/nouislider.css')

                // build range slider
                noUiSlider.create(rangeSlider, {
                    step: 100,
                    tooltips: {
                        to: (numericValue) => numericValue.toFixed(0),
                    },
                    connect: true,
                    start: [minValueDefault, maxValueDefault],
                    range: {
                        min: minValue,
                        max: maxValue,
                    },
                })

                // set hidden wpfacet fields
                const $inputMin = $('.facetwp-number-min')
                const $inputMax = $('.facetwp-number-max')
                rangeSlider.noUiSlider.on('slide', (values) => {
                    $inputMin.val(Number(values[0]).toFixed(0))
                    $inputMax.val(Number(values[1]).toFixed(0))
                })
            }

            // set trans label
            $('.facetwp-type-number_range .facetwp-submit').val(
                $('#priceRange').data('submit-label'),
            )
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    new BlockCustomerSejoursList()
})
